import { format } from "date-fns";
import { enAU } from 'date-fns/locale';
import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { CalendarIcon, XIcon } from 'lucide-react';

interface DatePickerProps {
  date?: Date
  setDate: (date?: Date) => void
  placeholder?: string
}

export const DatePicker = forwardRef<HTMLButtonElement, DatePickerProps>(({ date, setDate, placeholder }: DatePickerProps, ref) => {
  return (
    <Popover modal={true}>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-full justify-between text-left font-normal",
            !date && "text-muted-foreground"
          )}
          ref={ref}
        >
          <div className="flex flex-row items-center">
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? format(date, "PPP", { locale: enAU }) : placeholder || "Select date"}
          </div>
          {date && (
            <Button variant={"ghost"} size={"icon"} className="ml-2 p-0 m-0 justify-end text-foreground/50" onClick={(e) => { e.stopPropagation(); setDate(null) }}>
              <XIcon className="h-4 w-4" />
            </Button>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={setDate}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
});

